import { mapState, mapActions,mapGetters } from 'vuex'
import HttpFactory from '@/mixins/http.factory';
export default {
	mixins:[HttpFactory],
	data () {
		return {
			columnDefs:[],
      data: null,
      //auth only
			//baseUrl:config.baseUrl,
			//loading:false,
			isFormValidated:false,
			disableValidateBtn:true,
			//userMsg:{type:'info',list:[]},
			auth: {},
			isbtnClicked: false,
			isViewOnly: false,
			isViewOnlyMsg:'As a viewer, you are unable to use the "Azure DevOps Integration BiSync"',
			showCookiesBanner:true
		}
	},
	created () {
		this.init();
	},
	computed:{
		//...mapGetters(['monday/getMondayInfo']),
		//...mapState('monday',['mdMetadata']),
		...mapState('monday',['mondayInfo']),
		...mapState('mdDevops',['appData'])
	},
	mounted() {

	},
	methods:{
		async init(){
			let _self = this;
			 // Check if the consent cookie exists
  			window.onload = function () {
				if (document.cookie.includes("cookieConsent=true") || localStorage['cookieConsent_devops']==='true') {
					_self.showCookiesBanner = false;
					//document.getElementById('cookieBanner').style.display = 'none';
				}
			};


			mondayClient.execute("valueCreatedForUser");

			await this.$store.dispatch('monday/getMondayInfo');
			if (_self.mondayInfo && _self.mondayInfo.mondayMetaObj && _self.mondayInfo.mondayMetaObj.user) {
				_self.isViewOnly = _self.mondayInfo.mondayMetaObj.user.isViewOnly;
			}
			if (_self.isViewOnly == false) {
				await _self.getAppData();
				if (_self.mondayInfo.item && _self.mondayInfo.item.board) {
					await _self.fn().setUpdateMondayData_Child(_self.mondayInfo, _self.mondayInfo.item.board.id, _self.mondayInfo.item.id);
				}
			}
			//_self.fn().registerModalInstance();
		},
		acceptCookies: function () {
			const _self = this;
			// Hide the banner
			//document.getElementById('cookieBanner').style.display = 'none';
			_self.showCookiesBanner = false;

    		// Save consent in a cookie (expires in 30 days)
    		document.cookie = "cookieConsent=true; max-age=" + 30 * 24 * 60 * 60 + "; path=/";
			localStorage['cookieConsent_devops'] = true;
  		},
		async getAppData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			try{

				//await this.$store.dispatch('monday/getMondayMetadata');
				//await this.$store.dispatch('monday/getMondayInfo')

				_self.auth.hdLoginUrl=_self.mondayInfo.credentials.hdLoginUrl;
        _self.auth.hdEmail = _self.mondayInfo.user.email;

				await this.$store.dispatch('mdDevops/getAppData',{auth:_self.mondayInfo.credentials});
        _self.data = _self.appData;
        _self.mondayInfo.item = _self.appData.hdItem;
			}
			catch(ex){
				_self.commonErrorMsgDisp(ex);
			}
			_self.fn().showLoader(false);
			_self.setAppHeight();

		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }

            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.devOpsUrl && _self.auth.devOpsToken) {
                return true;
            }

            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('monday Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('monday Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('monday Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('monday Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('monday Email is  invalid.');
			}
            if (!_self.auth.devOpsUrl) {
                _self.userMsg.list.push('Azure DevOps Url is  required.');
            }else if(!_self.validUrl(_self.auth.devOpsUrl)){
                _self.userMsg.list.push('Azure DevOps Url is invalid.');
            }
            if (!_self.auth.devOpsToken) {
                _self.userMsg.list.push('Azure DevOps Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        authenticate(e,cb){
            let _self=this;
            if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.mondayInfo.credentials.appId;
			_self.auth.installationId=_self.mondayInfo.credentials.installationId;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate',
				url:'authenticate',
                headers: {'Content-Type': 'application/json'}
            };
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    _self.init();
					//window.location.reload();
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
		authenticate_modal() {
			let _self = this;
			//_self.authenticate_token_modal();
			_self.authenticate_outh2_modal();
		},
		authenticate_token_modal() {
			// https://developer.monday.com/apps/docs/mondayexecute
			let _self=this;
			var size = { width: '80vw', height: '70vh' };

			let mdItemId = _self.mondayInfo.item.id;
			let action = `authenticate_token/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}`;

			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.mondayInfo.item.board.id}/${mdItemId}/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}`
			}
			// if (_self.data && (_self.data.message == 'Unauthorized access...' || _self.data.message == 'Your API tokens expired/invalid. Please Re-Authenticate.')) {
			// 	action += `/${_self.data.mondayConfig.client_id}`;
			// }
			_self.fn().create_monday_modal(action, size, null, null, null, function () {
				_self.fn().clearMessage();
				_self.fn().showLoader(true);
				document.location.reload();
				//_self.getAppData();
			});
		},
		authenticate_outh2_modal() {
			// https://developer.monday.com/apps/docs/mondayexecute
			let _self=this;
			var size = { width: '50vw', height: '70vh' };

			let mdItemId = _self.mondayInfo.item.id;
			let action = `authenticate_outh2/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}`;

			if(_self.appData &&_self.appData.userInfo && _self.appData.userInfo.id){
				action+=`/${_self.mondayInfo.item.board.id}/${mdItemId}/${_self.appData.userInfo.id}/${encodeURIComponent(_self.appData.userInfo.devOpsUrl)}?userDetailId=${_self.appData.userInfo.userDetailId}`
			}
			if (_self.data && (_self.data.message == 'Unauthorized access...' || _self.data.message == 'Your API tokens expired/invalid. Please Re-Authenticate.')) {
				action += `/${_self.data.mondayConfig.client_id}`;
			}
			_self.fn().create_monday_modal(action, size, null, null, null, function () {
				_self.fn().clearMessage();
				_self.fn().showLoader(true);
				document.location.reload();
			 	//_self.getAppData();
			});
		},
		configure(){
			let _self=this;
			var size = { width: '80vw', height: '70vh' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(`configure/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					//_self.getAppData();
				}
			});
		},
		configureApp(){
			let _self=this;
			var size = { width: '80vw', height: '70vh' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(`configure-app/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					//_self.getAppData();
				}
			});
		},
		docsRedirect(){
			let redirectUrl='https://devopsintegration.io/docs/monday-devops';
			window.location.replace(redirectUrl);
		},
		createWorkItem(){
			let _self=this;
			var size={ width: '80vw',height: '100vh'};
			let cPath='';
			//console.log('data is',_self.data);
			//console.log('Cust ADO Org Is ',_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl));
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath = 'custom/devopsintegrationio/';
					break;
				}
			}
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(cPath + `create-work-item/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/` + mdItemId, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		searchWorkItem(){
			const _self=this;
			var size = { width: '80vw', height: '80vh' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(`search-work-item/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		notifyWorkItem(){
			let _self=this;
			var size = { width: '50vw', height: '80vh' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;

			_self.fn().create_monday_modal(`notify-work-item/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		linkWorkItem(){
			let _self=this;
			var size = { width: '40vw', height: '55vh' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(`link-work-item/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					_self.getAppData();
				}
			});
		},
		linkedItems(){
			let _self = this;
			var size = { width: '85vw', height: '85vh' };
			let mdItemId = _self.mondayInfo.item.id;
			let cPath='';
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath='custom/devopsintegrationio/';
					break;
				}
			}
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(cPath + `linked-items/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}`, size, null, null, null, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					//_self.getAppData();
				}
			});
		},
		enableSyncing(){
			let _self=this;
			//var size={ width: '50vw',height: '50vh'};
			var size={ width: '80vw',height: '100vh'};
			_self.fn().create_monday_modal(`enable-syncing/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}`,size,null,null,null,function(){
				//_self.getAppData();
			});
		},
		async workItemLog(linkData){
			let _self=this;
			var size = { width: '80vw', height: '100vh' };
			let mdItemId = _self.mondayInfo.item.id;
			let cPath='';
			//console.log('Cust ADO Org Is ',_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl));
			if(_self.data && _self.data.userInfo){
				switch(_self.fn().getDevOpsOrg(_self.appData.userInfo.devOpsUrl)){
					case 'devopsintegrationio1':
						cPath = 'custom/devopsintegrationio/';
					break;
				}
			}
			_self.mondayInfo.linkData = linkData;

			await _self.fn().setUpdateMondayData_Child(_self.mondayInfo, _self.mondayInfo.item.board.id, _self.mondayInfo.item.id);

			let triggerInstance = `work-item-log-dialog_md${linkData.hdItemId}_wd${linkData.workItemId}`;
			let action = cPath + `work-item-log/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${mdItemId}?hdItemId=${linkData.hdItemId}&workItemId=${linkData.workItemId}&devOpsTenant=${linkData.devOpsTenant}`;
			_self.isbtnClicked = true;
			_self.fn().create_monday_modal(action, size, triggerInstance, null, _self.mondayInfo, function () {
				if (_self.isbtnClicked == true) {
					_self.isbtnClicked = false;
					//_self.getAppData();
				}
			});
		},
		async resetCacheConfirm(){
			let _self=this;
			let linkData={hdItemId:_self.mondayInfo.item.id};
			var size={ width: '30vw',height: '8vw'};
			_self.mondayInfo.linkData=linkData;
			_self.mondayInfo.msg=`Do you want to reset the cache?`
			let triggerInstance=`confirm-dialog_md${linkData.hdItemId}_cacheReset`;
			let cbInstance=`remove-confirm-dialog_md${linkData.hdItemId}_cacheReset`;
			let action = `confirm-dialog/${_self.mondayInfo.credentials.appId}/${_self.mondayInfo.credentials.installationId}/${_self.mondayInfo.item.board.id}/${_self.mondayInfo.item.id}?hdBoardId=${linkData.hdBoardId}&hdItemId=${linkData.hdItemId}&cacheReset=${linkData.hdItemId}`;
			_self.isbtnClicked = true;
			mondayClient.execute("confirm", { message: _self.mondayInfo.msg, confirmButton: "Yes", cancelButton: "No", excludeCancelButton: false }).then((res) => {
				if (res.data.confirm == true) {
					_self.resetCache(linkData, _self.getAppData);
				} else {
					//_self.getAppData();
				}
			});

			// await _self.fn().setUpdateMondayData_Child(_self.mondayInfo, _self.mondayInfo.item.board.id, _self.mondayInfo.item.id);
			// _self.fn().create_monday_modal(action, size, triggerInstance, cbInstance, _self.mondayInfo, function (response) {
			// 	if (_self.isbtnClicked == true) {
			// 		_self.isbtnClicked = false;
			// 		if (response.Success && response.type == 'confirmed') {
			// 			_self.resetCache(linkData, _self.getAppData);
			// 		} else {
			// 			_self.getAppData();
			// 		}
			// 	}

			// });
		},
		resetCache(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth:_self.mondayInfo.credentials
			};
			//let url=`reset/cache/${linkData.hdBoardId}/${linkData.hdItemId}`;
			let url=`reset/cache/${_self.mondayInfo.item.id}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				mondayClient.execute("notice", { message: response.data.Data,type: "info", timeout: 10000,}); // or "error" (red), or "info" (blue) or success (green)
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		removeConfirm(linkData){
			let _self=this;
			var size = { width: '30vw', height: '8vw' };
			let mdItemId = _self.mondayInfo.item.id;
			_self.mondayInfo.linkData=linkData;
			_self.mondayInfo.msg=`Do you want to unlink Work item: #${linkData.workItemId}?`
			let triggerInstance=`confirm-dialog_md${linkData.hdItemId}_wd${linkData.workItemId}`;
			let cbInstance=`remove-confirm-dialog_md${linkData.hdItemId}_wd${linkData.workItemId}`;
			let action = `confirm-dialog/${_self.mondayInfo.item.board.id}/${mdItemId}?hdBoardId=${linkData.hdBoardId}&hdItemId=${linkData.hdItemId}&workItemId=${linkData.workItemId}&devOpsTenant=${linkData.devOpsTenant}`;

			mondayClient.execute("confirm", { message: _self.mondayInfo.msg, confirmButton: "Yes", cancelButton: "No", excludeCancelButton: false }).then((res) => {
				if (res.data.confirm == true) {
					_self.unlinkWorkItem(linkData,_self.getAppData);
				} else {
					//_self.getAppData();
				}
			});

			// _self.fn().create_monday_modal(action,size,triggerInstance,cbInstance,_self.mondayInfo,function(response){
			// 	if(response.Success && response.type=='confirmed'){
			// 		_self.unlinkWorkItem(linkData,_self.getAppData);
			// 	}else{
			// 		_self.getAppData();
			// 	}

			// });
		},
		unlinkWorkItem(linkData,cb){
			let _self=this;
			_self.fn().clearMessage();
			let data={
				auth: _self.mondayInfo.credentials,
				user:_self.mondayInfo.user
			};
			let url;
			if(linkData.devOpsTenant)
				url = `monday/unlink/${linkData.hdBoardId}/${linkData.hdItemId}/${linkData.workItemId}/${linkData.devOpsTenant}`;
			else
				url=`monday/unlink/${linkData.hdBoardId}/${linkData.hdItemId}/${linkData.workItemId}`;
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				if(cb) cb(response.data);
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		expandCollapse(linkedWorkItem,lnkInd){
			let _self=this;
			for(var i in _self.data.linkedItems)
				if(i!=lnkInd) _self.data.linkedItems[i].show = false;
			linkedWorkItem.show=!linkedWorkItem.show;
		},
		setAppHeight:function(){
			let _self=this;
			if(!_self.data) return;
            var linkedItems=_self.data.linkedItems;
            var height=170;
			height += (linkedItems && linkedItems.length > 0) ? (linkedItems.length * 85 + 230) : 75;
			if (_self.data && _self.data.userInfo && _self.data.userInfo.allowRelations == 1) {
				height += 20;
			}
			//client.instance.resize({ height: `${height}px` });
			//client.invoke('resize', {  height: `${height}px`})
        },
	},
	components:{}
}

// https://developer.monday.com/apps/docs/command-line-interface-cli#mapps-init
